import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, CONTACT } from "../lib/constants";

const ServicesPage = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
      }
    }
  }, [hash]);

  return (
    <div>
      <section className="ve-container pt-20 md:pt-28 pb-12 ve-noise">
        <span className="ve-eyebrow">Services</span>
        <h1 className="ve-display mt-6 text-[2.6rem] sm:text-4xl md:text-6xl lg:text-7xl max-w-5xl">
          Five mandates,<br />
          <em>handled personally.</em>
        </h1>
        <p className="mt-8 max-w-3xl text-base md:text-lg leading-relaxed" style={{ color: "var(--cream-200)" }}>
          Every mandate we take is handled by the proprietor, end to end — from shortlisting and site visits to title checks, price negotiations and registration. Below is exactly what we do, with the level of depth you can expect for each asset class.
        </p>
      </section>
      <div className="ve-rule" />
      {SERVICES.map((s, i) => (
        <section
          id={s.slug}
          key={s.slug}
          className={`${i % 2 === 1 ? "border-t" : "border-t"}`}
          style={{
            borderColor: "var(--hair)",
            background: i % 2 === 1 ? "var(--ink-900)" : "var(--ink-800)",
          }}
        >
          <div className="ve-container py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12">
            <div className="lg:col-span-5">
              <div className="ve-number">{String(i + 1).padStart(2, "0")} / {SERVICES.length.toString().padStart(2, "0")}</div>
              <h2 className="ve-display mt-4 text-4xl md:text-6xl">{s.title}</h2>
              <p className="mt-3 text-sm tracking-[0.14em] uppercase" style={{ color: "var(--gold-500)" }}>
                {s.short}
              </p>
            </div>
            <div className="lg:col-span-7">
              <p className="text-base md:text-lg leading-relaxed" style={{ color: "var(--cream-200)" }}>
                {s.body}
              </p>
              <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-px" style={{ background: "var(--hair)" }}>
                {s.points.map((p, j) => (
                  <li
                    key={j}
                    className="p-5 text-sm flex items-start gap-3"
                    style={{ background: i % 2 === 1 ? "var(--ink-900)" : "var(--ink-800)", color: "var(--cream-200)" }}
                  >
                    <span className="mt-1 inline-block w-2 h-2 rounded-full shrink-0" style={{ background: "var(--terra-500)" }} />
                    {p}
                  </li>
                ))}
              </ul>
              <div className="mt-10 flex flex-wrap gap-3">
                <a href={CONTACT.whatsappLink} target="_blank" rel="noreferrer" className="ve-btn-primary">
                  Discuss {s.title}
                </a>
                <a href={`tel:${CONTACT.phoneTel}`} className="ve-btn-ghost">
                  Call the Office
                </a>
              </div>
            </div>
          </div>
        </section>
      ))}
      <section className="border-t" style={{ borderColor: "var(--hair)", background: "var(--ink-800)" }}>
        <div className="ve-container py-20 md:py-24 flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <div className="max-w-2xl">
            <span className="ve-eyebrow">Not sure where to start?</span>
            <h2 className="ve-display mt-5 text-3xl md:text-5xl">
              Send us a line —<br />
              <em>we'll point you right.</em>
            </h2>
          </div>
          <div className="flex flex-wrap gap-3">
            <a href={CONTACT.whatsappLink} target="_blank" rel="noreferrer" className="ve-btn-primary">
              WhatsApp Us
            </a>
            <a href={`tel:${CONTACT.phoneTel}`} className="ve-btn-ghost">
              {CONTACT.phoneDisplay} <ArrowUpRight size={14} />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;